import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	Dsm5TeenDTO,
	Dsm5TeenRequest,
	Dsm5TeenSaveDTO,
} from '../DTO/forms-management/dsm5Teen';

export const dsm5Teen = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getDsm5TeenList: builder.query<SuccessResponse<Dsm5TeenDTO[]>, string>({
			query: (id) => ({
				url: `/web/form/dsm-five-teen/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['Dsm5TeenList'],
		}),
		deleteDsm5Teen: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/dsm-five-teen/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['Dsm5TeenList'],
		}),
		Dsm5TeenHasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/dsm-five-teen/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getDsm5TeenDraft: builder.query<
			SuccessResponse<Dsm5TeenSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/dsm-five-teen/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueDsm5TeenDraft: builder.mutation<
			SuccessResponse<Dsm5TeenSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/dsm-five-teen/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editDsm5Teen: builder.mutation<SuccessResponse<any>, Dsm5TeenRequest>({
			query: (body) => ({
				url: `/web/form/dsm-five-teen/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createDsm5Teen: builder.mutation<SuccessResponse<any>, Dsm5TeenRequest>({
			query: (body) => ({
				url: `/web/form/dsm-five-teen`,
				method: 'POST',
				body,
			}),
		}),
		getDsm5TeenDetail: builder.query<SuccessResponse<Dsm5TeenDTO>, string>({
			query: (id) => ({
				url: `/web/form/dsm-five-teen/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetDsm5TeenListQuery,
	useDeleteDsm5TeenMutation,
	useDsm5TeenHasDraftQuery,
	useGetDsm5TeenDraftQuery,
	useContinueDsm5TeenDraftMutation,
	useEditDsm5TeenMutation,
	useCreateDsm5TeenMutation,
	useGetDsm5TeenDetailQuery,
} = dsm5Teen;
